// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-deletion-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 80%;
  margin: auto;
}
.account-deletion-container .warning-para {
  text-align: start;
  margin-bottom: 20px;
  border: 1px solid gray;
  margin: auto;
  border-radius: 5px;
  padding: 20px;
  line-height: 0px;
  margin-top: 20px;
  background: #f8f9fa;
}
.account-deletion-container .warning-para p {
  font-size: 14px;
  line-height: 15px;
}
.account-deletion-container .warning-para p span {
  font-weight: 500;
}
.account-deletion-container .select-head {
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 20px;
}
.account-deletion-container .delete-content {
  line-height: 40px;
}
.account-deletion-container .delete-content .radio-input {
  margin-right: 5px;
  width: 14px;
  height: 10px;
}
.account-deletion-container .delete-content .delete-label {
  font-size: 16px;
  position: relative;
}
.account-deletion-container .del-btn {
  margin: auto;
  margin-top: 30px;
  background: #0c3688;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/component/DeleteAccount/deleteAccount.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AACJ;AACI;EACI,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACR;AACQ;EACI,eAAA;EACA,iBAAA;AACZ;AACY;EACI,gBAAA;AAChB;AAII;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAKI;EACI,iBAAA;AAHR;AAKQ;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AAHZ;AAMQ;EACI,eAAA;EACA,kBAAA;AAJZ;AAQI;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AANR","sourcesContent":[".account-deletion-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 80%;\n    margin: auto;\n\n    .warning-para {\n        text-align: start;\n        margin-bottom: 20px;\n        border: 1px solid gray;\n        margin: auto;\n        border-radius: 5px;\n        padding: 20px;\n        line-height: 0px;\n        margin-top: 20px;\n        background: #f8f9fa;\n\n        p {\n            font-size: 14px;\n            line-height: 15px;\n\n            span {\n                font-weight: 500;\n            }\n        }\n    }\n\n    .select-head {\n        font-weight: 400;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .delete-content {\n        line-height: 40px;\n\n        .radio-input {\n            margin-right: 5px;\n            width: 14px;\n            height: 10px;\n        }\n\n        .delete-label {\n            font-size: 16px;\n            position: relative;\n        }\n    }\n\n    .del-btn {\n        margin: auto;\n        margin-top: 30px;\n        background: #0c3688;\n        color: white;\n        padding: 10px 20px;\n        border-radius: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
